import React ,{ Component }             from 'react';
import { connect }                      from 'react-redux';
import { Link,Redirect }                from 'react-router-dom';
import {Field, reduxForm, reset}        from 'redux-form';
import Dropzone                         from 'react-dropzone';
import renderField                      from '../../../container/renderField';
import renderFieldTextArea              from '../../../container/renderFieldTextArea';
import renderFieldSelec                 from '../../../container/renderFieldSelect';
import renderFieldRadio                 from '../../../container/renderFieldRadio';
import validate                         from '../../../service/validate_questao';
import { getDisciplinaPerfil }          from '../../../actions/batalhaAction';
import { SetByCadastrarQuestaoDuelo,
         GetByAprovarQuestoesDuelo,
         SetUploadFiles,
         EditarQuestao }                from '../../../actions/questaoActions';         
import { SetError }                     from '../../../actions/notificacaoAction';
import { GetListaMenuTopo,
         GetListaSubMenuTopo }          from '../../../actions/scopoAction';

class Questao extends Component {

    constructor(props){

        super(props);
        this.state = {
                      due_que_id       : 0,
                      usu_id           : this.props.session.id,
                      usu_id_edicao    : 0,
                      per_id           : this.props.session.perfil,
                      cur_id           : (this.props.session.curso ? this.props.session.curso : null),
                      disciplinaPerfil : [],
                      dir              : false
                    };  
        
        this.uploadImagemPublicacao = this.uploadImagemPublicacao.bind(this);

    }

    componentWillMount(){

        this.props.getDisciplinaPerfil(this.state.usu_id,this.state.per_id,this.state.cur_id).then((response) =>{
            if(!response.payload.data){alert("Você não está vinculado a nenhuma unidade curricular até o momento.");}  
        }).catch((error) =>{
            this.props.SetError(500);
        });
        
        if(this.props.match) {
            if(this.props.match.params.id>0) {
                this.renderFormQuestao();
            }  
        }        

        this.props.GetListaMenuTopo([
            {
              action : true,
              nome   : "Home",
              link   : this.props.menu.home
            },
            {
              action : true,
              nome   : this.props.menu.batalha.nomeModulo,
              link   : this.props.menu.batalha.professor.home
            },
            {
             action : false,
             nome   : ( this.props.match.params.id > 0 ?"Editar" : "Cadastro" )
            }
           ]);

           this.props.GetListaSubMenuTopo([]);
    }

    renderFormQuestao(){

        this.props.EditarQuestao(this.props.match.params.id).then((response)=>{

            this.setState({ 
                            due_que_id    : response.data.due_que_id,
                            usu_id_edicao : response.data.due_que_cod_usuario,
                            due_que_anexo : response.data.due_que_anexo
                          });
            
            const initData = { 
                                due_que_id        : response.data.due_que_id,
                                due_que_anexo     : response.data.due_que_anexo,
                                cad_questao_duelo : response.data.due_que_pergunta,
                                cad_questao_a     : response.data.due_que_opcao_a,
                                cad_questao_b     : response.data.due_que_opcao_b,
                                cad_questao_c     : response.data.due_que_opcao_c,
                                cad_questao_d     : response.data.due_que_opcao_d,
                                cad_questao_dis   : response.data.due_que_cod_disciplina+'#'+response.data.due_que_semestre,
                                optionQuestao     : response.data.due_que_resposta
                              }

          this.props.initialize(initData);
         }).catch((error) =>{
            this.props.SetError(500);
        });

    }
   
    uploadImagemPublicacao(){
        this.props.SetUploadFiles(this.state.due_que_id,this.state.files).then((response)=>{
          this.removeImgSelect();
        })
    }

    onDrop(files) {
       this.setState({selectedImg:files[0].preview,files:files,upload:1,publicImg:true});
    }

    removeImgSelect(){
       this.setState({selectedImg:[],publicImg:false,post_tipo:1})
    }

    handleSubmit(e) {

         this.props.SetByCadastrarQuestaoDuelo(e,this.state.usu_id,this.state.per_id,this.state.due_que_id,this.state.usu_id_edicao).then(

            (response) =>{

              alert('Questão enviada com sucesso!');
              this.setState({dir:true, due_que_id : (this.props.match ? this.props.match.params.id : response.data.duelo_questao.due_que_id)})
              if(this.state.upload === 1){this.uploadImagemPublicacao();}
              
            }).catch((error) =>{
               this.props.SetError(500);
            });

    }

    render() {
       
       const {handleSubmit} = this.props;

       if (this.state.dir) {
            return  <Redirect to={{ pathname:this.props.menu.batalha.professor.home}}/>;
        } 

        return (
            <div className="container-bg">
            
            <div className="panel panel-default">
                <div className="panel-heading"><b>Crie questões para a batalha</b></div>
                <div className="panel-body">

                      <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                       
                        <Field name="cad_questao_duelo" type="textarea" component={renderFieldTextArea} label="Pergunta"/>
                        <Field name="cad_questao_a"     type="text" component={renderField} label="Opção A)"/>
                        <Field name="cad_questao_b"     type="text" component={renderField} label="Opção B)"/>
                        <Field name="cad_questao_c"     type="text" component={renderField} label="Opção C)"/>
                        <Field name="cad_questao_d"     type="text" component={renderField} label="Opção D)"/>
                        <Field name  = "cad_questao_dis"
                            component   = {renderFieldSelec}
                            label       = "Unidade Curricular"
                            option      = {this.props.disciplinas.map((elem) =>{ return <option key = {elem.dis_id} value = {elem.dis_id+'#'+elem.dis_semestre}>{elem.dis_nome} </option>}) }
                        />

                         {!this.state.due_que_anexo? "": <ol className="breadcrumb"><li><a href={this.state.due_que_anexo} target='_blank'>Visualizar imagem</a> </li></ol>}
                        <Dropzone 
                            className = "btn btn-primary btn-sm btn-block"
                            multiple  = {false}
                            accept    = "image/png,image/jpeg"
                            onDrop    = {this.onDrop.bind(this)}>
                            <div><span className="glyphicon glyphicon-camera"></span> Selecionar imagem.</div>
                        </Dropzone>

                         {this.state.publicImg? 
                            <div className="selected_img_post">
                               <img src={this.state.selectedImg} width="120" alt="Imagem" className="img-rounded"/>
                               <p><a href={void(0)} onClick={this.removeImgSelect.bind(this)}>Excluir</a></p>
                            </div>:""
                         }
                        <Field name="optionQuestao" type="radio" component={renderFieldRadio} value="a" label=" Opção: A "/>
                        <Field name="optionQuestao" type="radio" component={renderFieldRadio} value="b" label=" Opção: B "/>
                        <Field name="optionQuestao" type="radio" component={renderFieldRadio} value="c" label=" Opção: C "/>
                        <Field name="optionQuestao" type="radio" component={renderFieldRadio} value="d" label=" Opção: D "/>
                        <div className="form-group">
                           <Link to={this.props.menu.batalha.professor.home} className="btn-primary btn-xs pull-left"> Sair</Link>   
                           <button type="submit" className="btn-primary btn-xs pull-right">Enviar</button>
                        </div>
                    </form>   
                </div>
            </div>
            </div>
        );
    }
}
const afterSubmit = (result, dispatch) => dispatch(reset('QuestaoForm'));

function mapStateToProps(state){

    return {
             session     : state.auth.session,
             disciplinas : state.batalhaReducer.allDisciplina,
             formQuestao : state.batalhaReducer.editarquestao,
             menu        : state.configReducer.menu,
             config      : state.configReducer.config
           }
}

export default reduxForm({
    form                     : 'QuestaoForm', 
    destroyOnUnmount         : true,
    forceUnregisterOnUnmount : true,
    onSubmitSuccess          : afterSubmit,
    validate
})(connect(mapStateToProps,{getDisciplinaPerfil,SetByCadastrarQuestaoDuelo,GetByAprovarQuestoesDuelo,SetError,SetUploadFiles,EditarQuestao,GetListaMenuTopo,GetListaSubMenuTopo})(Questao));





// WEBPACK FOOTER //
// ./src/components/professor/questao/questao.js